import useFindUser from './useFindUser';

export default function useAuthContextValue() {
  const {
    user,
    roles,
    positions,
    setUser,
    isLoading: findUserIsLoading,
  } = useFindUser();

  const isAdmin = Boolean(
    user?.is_superuser || user?.roles?.some((role) => role.code === 'ADMIN'),
  );
  const isUniversity = user?.roles?.some((role) => role.code === 'UNI');
  const isStudent = user?.roles?.some((role) => role.code === 'STD');
  const isExpert = user?.roles?.some((role) => role.code === 'EXP');

  const isLoggedIn = !!user;

  const derivedIsLoading =
    findUserIsLoading || (!!localStorage.getItem('uuid') && !user);

  return {
    user,
    setUser,
    roles,
    positions,
    isLoading: derivedIsLoading,
    isLoggedIn,
    isAdmin,
    isUniversity,
    isStudent,
    isExpert,
  };
}
